import Vue from 'vue';
// import * as utils from 'utils';
import services from './index';


let vue;
const eventHub = new Vue();

function isPromise(val) {
    return val && typeof val.then === 'function';
}

const Service = {
    created() {
        vue.util.defineReactive(this, '$service', this.$$service());
        vue.util.defineReactive(this, '$pending', {});
        vue.util.defineReactive(this, '$eventHub', eventHub);
    },
    methods: {
        $$service() {
            const $service = {};
            const self = this;
            Object.keys(services).forEach((key) => {
                const service = services[key];
                $service[key] = (...params) => {
                    const result = service.call(self, ...params);
                    if (!isPromise(result)) {
                        return result;
                    }
                    this.$set(this, '$pending', {
                        ...this.$pending,
                        [key]: true,
                    });
                    return result
                        .then((data) => {
                            this.$set(this, '$pending', {
                                ...this.$pending,
                                [key]: false,
                            });
                            return data;
                        })
                        .catch((error) => {
                            if (typeof error === 'string') {
                                error = new Error(error);
                            }

                            this.$set(this, '$pending', {
                                ...this.$pending,
                                [key]: false,
                            });

                            throw error;
                        });
                };
            });

            return $service;
        },
    },
};

export default {
    mixin: Service,
    install(Vue) {
        vue = Vue;
        Vue.options = Vue.util.mergeOptions(Vue.options, Service);
    },
};
